/**
 * Feature flags configuration
 */

const getFeatureFlag = (key: string, defaultValue: boolean = false): boolean => {
  const value = import.meta.env[`VITE_FEATURE_${key.toUpperCase()}`];
  return value === 'true' || defaultValue;
};

export const features = {
  enableSSO: getFeatureFlag('ENABLE_SSO', true),
  enableMFA: getFeatureFlag('ENABLE_MFA', false),
  enableAuditLogging: getFeatureFlag('ENABLE_AUDIT_LOGGING', true),
  enableRealtimeUpdates: getFeatureFlag('ENABLE_REALTIME_UPDATES', false),
  enableAnalytics: getFeatureFlag('ENABLE_ANALYTICS', false),
  enableBetaFeatures: getFeatureFlag('ENABLE_BETA_FEATURES', false),
  enableDarkMode: getFeatureFlag('ENABLE_DARK_MODE', true),
  enableOfflineMode: getFeatureFlag('ENABLE_OFFLINE_MODE', false),
  enablePublicAccessToggle: getFeatureFlag('ENABLE_PUBLIC_ACCESS_TOGGLE', false),
} as const;
